import 'vanilla-cookieconsent/dist/cookieconsent.css';
import * as CookieConsent from 'vanilla-cookieconsent';
import { useEffect } from 'react';
import ThemeProvider from './utils/shared/ThemeContext';
import cookieConfig from './config/cookie';
import { QueryClientProvider } from '@tanstack/react-query';
import '@/css/additional-styles/originui.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-loading-skeleton/dist/skeleton.css';
import { SkeletonTheme } from 'react-loading-skeleton';
import { AppRouter } from './router';
import { ErrorFrame } from './shared/components/error-frame';
import { AppSplash } from './components/app-splash';
import { queryClient } from './lib/tanstack-query';

export function App() {
  useEffect(() => {
    // Shows the consent banner if needed and loads scripts marked
    // data-category="marketing" (Meta Pixel) only after consent
    CookieConsent.run(cookieConfig);
  }, []);

  return (
    <ThemeProvider>
      <SkeletonTheme baseColor="#E5E7EB" borderRadius={20}>
        <QueryClientProvider client={queryClient}>
          <ErrorFrame pendingFallback={<AppSplash />}>
            <AppRouter />
          </ErrorFrame>
        </QueryClientProvider>
      </SkeletonTheme>
    </ThemeProvider>
  );
}
